/**
 * @license
 * Copyright Santander UK. All Rights Reserved.
 */
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FooterControlComponent } from 'ui-common-components-angular';
import { StartupService } from '../services/startup.service';
import { constants } from './../../configs/config-internal-constants';
import { externalRoutes, externalCahootRoutes } from './../../configs/config-internal-content';
import { BrandService } from '../services/brand-service';

@Component({
    selector: 'olb-app-footer',
    templateUrl: `./footer.component.html`,
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FooterControlComponent]
})
/**
 * This component provides functionality for footer component
 */
export class FooterComponent implements OnInit {
  @ViewChild('myFooter') footerControl: FooterControlComponent;

  dataFooterLinks: FooterLink[];
  public isCahoot = false;

  constructor(private startup: StartupService,
              private brandService: BrandService
              ) {}

  ngOnInit() {
    this.isCahoot = this.brandService.isCahoot();
    this.dataFooterLinks = this.getFooters();
  }

  getFooters(): FooterLink[] {
    return [
      {
        id: 1,
        name: constants.ONLINE_BANKING_GUARANTEE,
        url: (this.isCahoot) ? this.startup.externalCahoot + externalCahootRoutes.ONLINE_BANKING_GUARANTEE
           : this.startup.externalSantander + externalRoutes.ONLINE_BANKING_GUARANTEE,
      },

      {
        id: 2,
        name: constants.SITE_HELP_ACCESSIBILITY,
        url: (this.isCahoot) ? this.startup.externalCahoot + externalCahootRoutes.SITE_HELP_AND_ACCESIBILITY
         : this.startup.externalSantander + externalRoutes.SITE_HELP_AND_ACCESIBILITY,
      },

      {
        id: 3,
        name: constants.SECURITY_PRIVACY,
        url: (this.isCahoot) ? this.startup.externalCahoot + externalCahootRoutes.SECURITY_AND_PRIVACY
           : this.startup.externalSantander + externalRoutes.SECURITY_AND_PRIVACY,
      },

      {
        id: 4,
        name: constants.TERMS_CONDITIONS,
        url: (this.isCahoot) ? this.startup.externalCahoot + externalCahootRoutes.TERMS_AND_CONDITION
           : this.startup.externalSantander + externalRoutes.TERMS_AND_CONDITION,
      },

      {
        id: 5,
        name: constants.LEGAL,
        url: (this.isCahoot) ? this.startup.externalCahoot + externalCahootRoutes.LEGAL
           : this.startup.externalSantander + externalRoutes.LEGAL,
      },
    ];
  }
}

export interface FooterLink {
  id: number;
  name: string;
  url: string;
}
